import React, { ReactNode, useState } from "react";
import "../CSS/ProfileExpandableSection.css";
import collapsedArrowIcon from "../../../assets/images/profile-collapsed-arrow-icon.svg";

interface ProfileExpandableSectionProps {
  title: string;
  subTitle: string;
  children: ReactNode;
}

const ProfileExpandableSection: React.FC<ProfileExpandableSectionProps> = ({
  title,
  subTitle,
  children,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        className="profile-screen-details-container"
        onClick={() => setExpanded((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
         <span>
          {title} <span style={{ color: "#ff6b35" }}>{subTitle}</span>
        </span>
        <div className="profile-screen-details-expand-container">
          <img
            src={collapsedArrowIcon}
            alt="collapsed-arrow-icon"
            style={{
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s",
            }}
          />
        </div>
      </div>
      {expanded && (
        <div className="profile-screen-details-content">{children}</div>
      )}
    </div>
  );
};

export default ProfileExpandableSection;
